module.exports = require './content-header'
